<template>
  <!-- Questionnaire Screen -->
  <div class="centered-card">
    <h2>Premium User Questionnaire</h2>
    <p>Please answer the following questions to help tailor your troubleshooting experience:</p>
    <div class="form-group">
      <label>1. What would you like Pocket Journeyman to accomplish for you?</label>
      <div>
        <label>
          <input type="radio" value="fixBasic" v-model="questionnaire.accomplish" />
          I want to fix basic issues to prevent nuisance service calls and save money.
          <br /><small>Estimated savings per repair: $50–$150</small>
        </label>
      </div>
      <div>
        <label>
          <input type="radio" value="handleRoutine" v-model="questionnaire.accomplish" />
          I want to handle routine maintenance and minor repairs on my own.
          <br /><small>Estimated savings per repair: $100–$300</small>
        </label>
      </div>
      <div>
        <label>
          <input type="radio" value="manageCommon" v-model="questionnaire.accomplish" />
          I want to manage common repair tasks with some expert guidance.
          <br /><small>Estimated savings per repair: $200–$500</small>
        </label>
      </div>
      <div>
        <label>
          <input type="radio" value="tackleChallenging" v-model="questionnaire.accomplish" />
          I want to tackle more challenging issues with detailed step-by-step instructions.
          <br /><small>Estimated savings per repair: $300–$700</small>
        </label>
      </div>
      <div>
        <label>
          <input type="radio" value="solveAll" v-model="questionnaire.accomplish" />
          I want to solve all problems myself even the complex ones.
          <br /><small>Estimated savings per repair: $500–$1500</small>
        </label>
      </div>
    </div>
    <div class="form-group">
      <label>2. How much experience do you have with tools/power tools?</label>
      <div>
        <label>
          <input type="radio" value="none" v-model="questionnaire.toolExperience" />
          No experience at all.
        </label>
      </div>
      <div>
        <label>
          <input type="radio" value="beginner" v-model="questionnaire.toolExperience" />
          Beginner (limited use).
        </label>
      </div>
      <div>
        <label>
          <input type="radio" value="intermediate" v-model="questionnaire.toolExperience" />
          Intermediate (some familiarity).
        </label>
      </div>
      <div>
        <label>
          <input type="radio" value="advanced" v-model="questionnaire.toolExperience" />
          Advanced (comfortable with power tools).
        </label>
      </div>
      <div>
        <label>
          <input type="radio" value="expert" v-model="questionnaire.toolExperience" />
          Expert (extensive/professional experience).
        </label>
      </div>
    </div>
    <div class="form-group">
      <label>3. What tools do you currently have access to?</label>
      <div>
        <label>
          <input type="radio" value="basicHand" v-model="questionnaire.toolsAccess" />
          Only basic hand tools (hammer, screwdriver, etc.).
        </label>
      </div>
      <div>
        <label>
          <input type="radio" value="fewPower" v-model="questionnaire.toolsAccess" />
          A few basic power tools (drill, saw, etc.).
        </label>
      </div>
      <div>
        <label>
          <input type="radio" value="standardDIY" v-model="questionnaire.toolsAccess" />
          A standard DIY toolkit.
        </label>
      </div>
      <div>
        <label>
          <input type="radio" value="wellEquipped" v-model="questionnaire.toolsAccess" />
          A well-equipped home workshop.
        </label>
      </div>
      <div>
        <label>
          <input type="radio" value="professional" v-model="questionnaire.toolsAccess" />
          Professional-grade or commercial tools.
        </label>
      </div>
    </div>
    <button class="primary-button" @click="finishProfileandQuestionnaire">Save Profile &amp; Continue</button>
  </div>
</template>

<script>
export default {
  name: "Questionnaire",
  props: {
    initialData: {
      type: Object,
      default: () => ({
        accomplish: "",
        toolExperience: "",
        toolsAccess: ""
      })
    }
  },
  data() {
    return {
      questionnaire: { ...this.initialData  } // Initialize with props data
   };
  },
  methods: {
    // This method should emit an event or trigger a function in the parent component
    // to handle saving the profile and subscription. For example:
    finishProfileandQuestionnaire() {
      // Emit an event with the questionnaire data
      this.$emit("submit-questionnaire", this.questionnaire);
    }
  }
};
</script>

<style scoped>
/* Add any relevant styles here */
.centered-card {
  max-width: 600px;
  margin: auto;
  padding: 1rem;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.form-group {
  margin-bottom: 1rem;
}
.primary-button {
  padding: 0.5rem 1rem;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.primary-button:hover {
  background-color: #0056b3;
}
</style>
